import { defineMessages } from 'react-intl';

const translations = {
  confirmCancelOrder: {
    title: {
      id: 'confirmCancelOrder.title',
      defaultMessage: 'Cancel order',
      description: 'Cancel order confirm dialog title',
    },
    description: {
      id: 'confirmCancelOrder.description',
      defaultMessage: 'Are you sure you would like to cancel this order?',
      description: 'Cancel order confirm dialog description',
    },
    buttons: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'Cancel order confirm dialog cancel button label',
      },
      continue: {
        id: 'actions.continue',
        defaultMessage: 'Continue',
        description: 'Cancel order confirm dialog continue button label',
      },
    },
  },
  feedback: {
    orderCancelled: {
      id: 'confirmCancelOrder.feedback.orderCancelled',
      defaultMessage: 'Order cancelled',
      description: 'Order cancel success message',
    },
    orderNotCancelled: {
      id: 'confirmCancelOrder.feedback.orderNotCancelled',
      defaultMessage: 'Order could not be cancelled',
      description: 'Order cancel error message',
    },
  },
};

export default defineMessages(translations);
